import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { Typography, Avatar } from '@material-ui/core';
import { lightBlue, deepOrange, blue, green, yellow } from '@material-ui/core/colors';
import EditIcon from "@material-ui/icons/Edit";
import DescriptionIcon from '@material-ui/icons/Description';
import AttachMoneyIcon from '@material-ui/icons/AttachMoney';
import MoneyOffIcon from '@material-ui/icons/MoneyOff';
import clsx from 'clsx';

const useStyles = makeStyles({
  avatar: {
    height: 22,
    width: 22,
    margin: '0 10px 0 10px',
  },
  iconEdit: {
    backgroundColor: lightBlue[500],
  },
  iconDescriptionOrange: {
    backgroundColor: deepOrange[300]
  },
  iconDescriptionBlue: {
    backgroundColor: blue[700],
  },
  divBox: {
    display: 'flex',
    flexDirection: 'column'
  },
  divItem: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'flex-end',
    marginBottom: 5
  },
  icon: {
    fontSize: 14,
  },
  pago: {
    backgroundColor: green[500],
  },
  naoPago:{
    backgroundColor: yellow[700],
  },
  row:{
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'flex-end',
  },
  primeiraLinha: {
    marginBottom: 10
  }
});

export default function Legendas(props) {
  const classes = useStyles();
  const { title } = props
  return (
    <>
      <div className={classes.divItem}>
        {title === "Pronto para Retirada" &&
          <div className={classes.box}>
            <div className={classes.row}>
              <Typography variant="subtitle2">Pagamento Aprovado</Typography>
              <Avatar className={clsx(classes.avatar, classes.pago)}>
                <AttachMoneyIcon className={classes.icon} />
              </Avatar>

              <Typography variant="subtitle2">Aguardando Pagamento</Typography>
              <Avatar className={clsx(classes.avatar, classes.naoPago)}>
                <MoneyOffIcon className={classes.icon} />
              </Avatar>

              <Typography variant="subtitle2">Pedido está em edição ou foi editado</Typography>
              <Avatar className={clsx(classes.avatar, classes.iconEdit)}>
                <EditIcon className={classes.icon} />
              </Avatar>

            </div>
          </div>
        }
      </div>
    </>
  );
}
